import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Smart redirect after login based on role.
 *  - platform_admin → /admin
 *  - tenant_owner / tenant_staff / tenant_driver → /app
 *  - customer (no tenant) → /
 */
export default function Me() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Lade…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "platform_admin") return <Navigate to="/admin" replace />;
  if (user.role === "tenant_driver") return <Navigate to="/driver" replace />;
  if (["tenant_owner", "tenant_staff"].includes(user.role)) return <Navigate to="/app" replace />;
  // Customer: route to their tenant portal account
  if (user.role === "customer") {
    if (user.tenant_slug) return <Navigate to={`/portal/${user.tenant_slug}/account`} replace />;
    if (user.tenant_id) return <CustomerRedirect tenantId={user.tenant_id} />;
  }
  return <Navigate to="/login" replace />;
}

function CustomerRedirect({ tenantId }) {
  const [slug, setSlug] = React.useState(null);
  React.useEffect(() => {
    import("@/lib/api").then(({ default: api }) =>
      api.get("/customer/me").then((r) => setSlug(r.data.tenant?.slug || "")).catch(() => setSlug(""))
    );
  }, [tenantId]);
  if (slug === null) return <div className="min-h-screen flex items-center justify-center">Lade…</div>;
  if (!slug) return <Navigate to="/" replace />;
  return <Navigate to={`/portal/${slug}/account`} replace />;
}
